import { RestrictedWordMatch } from '@api'

export const getBlacklistedWordMatch = (
  message: string,
): RestrictedWordMatch | undefined => {
  if (!message.startsWith('Bad word detected')) return

  const blacklistedWordDetection = JSON.parse(
    message.match(/\{.*\}/)?.[0] ?? '{}',
  )

  if (
    'restrictedWord' in blacklistedWordDetection &&
    'restrictionType' in blacklistedWordDetection
  ) {
    return blacklistedWordDetection
  }
}

export class BlacklistedWordDetectionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'BlacklistedWordDetectionError'
  }
}
